import { gql } from "@apollo/client";

export const GET_SOLICITUD_CREDITICIA = gql`
query GetSolicitudCrediticia(
        $idEvaluacion: Int!
    ){
        solicitudCrediticiaByEvaluacion(idEvaluacion: $idEvaluacion){
            idEvaluacion,
            observacionCrediticia,
            idEstadoCrediticio,
            fechaEstadoCrediticio,
            idPacienteNavigation {
              idPaciente,
              nombre,
              apellido
            },
            idMotivoCrediticioNavigation {
              idMotivoResolucionCrediticia,
              motivoBloqueo
            },
            idUsuarioAutorizadorNavigation {
              apellido,
              nombre
            },
            idEstadoCrediticioNavigation {
              idEstadoCrediticio,
              descripcion
            },
        }
}`;